import { useState, useRef } from "react";
import Config from "../../Config.js";

import g_juz_spie from "../../alerts/juz_spie_z.png";
import g_obudzilem_sie from "../../alerts/obudzilem_sie_z.png";
import g_ide_na_spacer from "../../alerts/ide_na_spacer_z.png";
import g_wrocilem from "../../alerts/wrocilem_z.png";
import g_mam_bieginke from "../../alerts/mam_biegunke_z.png";
import g_kupka from "../../alerts/kupka_z.png";
import g_mam_goraczke from "../../alerts/mam_goraczke_z.png";

import InputPagger from "../../helpers/InputPagger.js";

import gochat from "../../gochat.png";


import InputTextAlpha from "../../helpers/InputTextAlpha.js";
import InputCombo from "../../helpers/InputCombo.js";
import InputLegend from "../../helpers/InputLegend.js";
import InputComboGrupa from "../../helpers/InputComboGrupaE.js";


//import KidDelete from "./KidDelete";
import AlertsNew from "./AlertsNew.js";

//import Start from "./Start";
import QuickChat from "../msgE/QuickChat.js";
import SortBy from "../../helpers/SortBy.js";
import MenuTable from "../../helpers/MenuTable.js";
//import KidDeleteMass from "./KidDeleteMass";


function Alerts(props)
{
    //do przemyslenia
    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        r_imie_nazwisko:  props.mainView.readFilter('r_imie_nazwisko',''), 
        p_grupa_id: '_x_',
        archiwalne: props.mainView.readFilter('archiwalne','0'),

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    
    const [optionTakNie, setOptionTakNie]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );
    
    const tabRef = useRef(0); //do druku

    

    

    


    const [view, setView] = useState ('link');

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko przeniesione do archiwum',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    

    

    if( gr == null ||  gr.length == 0 )
    {
            getGr();
            
            return <div></div>;                 
            
    }






    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    
    var id    = e.currentTarget.getAttribute('atr-id');   
        

    for(var k=0; k<selectedRow.length; k++)
    {
    
        //console.log('changeSelectedAll',id+' '+selectedRow[k].p_grupa_id);    
        
        if(id==selectedRow[k].p_grupa_id || id==0)
        {   
            
            
            var s = selectedRow[k].selected;
            if(s == 1) {  s = 0; } else s = 1;

            //console.log('changeSelectedAll 1',selectedRow[k].selected);

            selectedRow[k].selected = s;

            //console.log('changeSelectedAll 2',selectedRow[k].selected);
        }
        
    }
    
    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 
    
}



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,kidsE_alerts', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                p_grupa_id: item.p_grupa_id	,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);
                        
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }

    

    const goNextNew = () => {
        
        setTab(null);    
    }

    

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('r_imie_nazwisko', '');
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('archiwalne', '0');

        setFilterParam({ 
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '',
            p_grupa_id: '_x_',
            archiwalne: 0,    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }

    const onBack = ( ) => {                
        setTab(null); 
        setView('link');  
        
    }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView('link');
    
            var zaznaczonych = 0;
            var arrSelected = new Array();         
            for(var s=0; s<selectedRow.length; s++)
            {
                if(selectedRow[s].selected == 1) 
                {
                    zaznaczonych ++;
                    arrSelected.push( selectedRow[s] );                    
                }
            }
        }

    if(tab == null)
    {
        setTab([]);
        getTab();
        setView('link');       

        return <div>
            ...
        </div>
    }


    


    
    const changeView = (view) => {
        
        if(view=='reload')
        {
            setView('link');
            setTab(null); 
        }
        else{
            setView(view);   
        }

        return <div>
            ...
        </div>
    }


    




    var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
]

 

    var xwindow = null;

    var is_mobile = props.mainView.isMobile();

   


        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }

    

    var table = '';    
   
    

    //if(is_mobile)
    //{   

        table = gr.map( (grupa, ix) => {

                var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title)

                if(grupa.v!='_x_')

                if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
                {
                    
                    return <div className='mobile_table'>

                    

                    <div className="mobile_th button_object" atr-id={grupa.v} onClick={changeSelectedAll}>{grupa.title}  ({grupa_dzieci.length})  <span className="goRightFL">zaznacz</span></div>
                        <div className="mobile_tb">
                        {
                            grupa_dzieci.map( (dziecko, ix2) => {

                                var isChecked = '';

                                for(var s=0; s<selectedRow.length; s++)
                                {
                                    if( selectedRow[s].id == dziecko.id &&  selectedRow[s].selected === 1) isChecked = "checked";
                                }    


                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            <input type="checkbox" atr-id={dziecko.id} onChange={changeSelected} checked={isChecked} />
                                        </div>
                                        <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                        
                                        {
                                            dziecko.alerty.map( (row, ix3) => {

                                                var css_zealizowano = 'layette_incomplete';
            
                                                var img = '';
            
                                                if(row.typ==='SLEEP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_juz_spie}></img>;
                                                if(row.typ==='SHI') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_mam_bieginke}></img>;
                                                if(row.typ==='TEMP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'}  title={row.info} src={g_mam_goraczke}></img>;
                                                if(row.typ==='WALK') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_ide_na_spacer}></img>;
                                                if(row.typ==='AWAKE') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_obudzilem_sie}></img>;
                                                if(row.typ==='KKP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_kupka}></img>;
                                                if(row.typ==='BACK') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} title={row.info} src={g_wrocilem}></img>;
                                                
                                                return <div className='kid_row_img'  >
                                                    {img}
                                                </div>
                                            })
                                        }
                                        
                                        
                                    </div>
                                
                            })
                        }    
                        </div>
                    </div>
                }
                
                

            }
        )

    /*    
    }
    
    {
        table = (<div>

                <div className="mobile_table">
                    <AlertsNew mainView={props.mainView} view={view} onBack={changeView} userData={props.userData} tabSelected={selectedRow}  className={"gocenter nbx_squre txtcloud "}  onSucess={getTab} title={ tab.nazwisko + " " + tab.imie } ></AlertsNew>       
                    <br></br><br></br>
                </div>

            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                
                                                <td>Grupa</td>  
                                                <td>Nazwisko, imię</td>    
                                                <td>Powiadomienia</td>  
                                                <td atr-id='0' onClick={changeSelectedAll}>Zaznacz</td>
                                                
                                          
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var cls = "";
                                                    if(row.archiwalne == '1') cls = "color_deleted";


                                                    var isChecked = "";

                                                    for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle + cls}  key={ix+"r"} > 

                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="link_normal"  onClick={changeView} v="show" id={row.id}>{row.grupa}</td>
                                                            <td  onClick={changeView} v="show" id={row.id} className="link_normal">{row.nazwisko + " " + row.imie  }</td>
                                                            <td  className="link_normal" >
                                                            {
                                            row.alerty.map( (row, ix3) => {

                                                var css_zealizowano = 'layette_incomplete';
            
                                                var img = '';
            
                                                if(row.typ==='SLEEP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_juz_spie}></img>;
                                                if(row.typ==='SHI') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_mam_bieginke}></img>;
                                                if(row.typ==='TEMP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_mam_goraczke}></img>;
                                                if(row.typ==='WALK') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_ide_na_spacer}></img>;
                                                if(row.typ==='AWAKE') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_obudzilem_sie}></img>;
                                                if(row.typ==='KKP') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_kupka}></img>;
                                                if(row.typ==='BACK') img = <img  v="show" id={row.id} className={css_zealizowano+' wyprawka_img'} src={g_wrocilem}></img>;
                                                
                                                return <div className='kid_row_alerts' >
                                                    {row.info} |
                                                </div>
                                            })
                                        }
                                                            </td>
                                                            <td className="gocenter">
                                                                <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} /> 
                                                            </td>
                                                           
                                                    
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
        </div>)   
    }    
    */
    return (

        <div className="view_content">
            
            {xwindow}

           


            <div className="table_filter mobile_filters">
                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  
 
                        



                            <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>
                            
            </div>
            

            <div className="bg_center css_mobile_to_stac">
                
            <div className="mobile_table">
                    <AlertsNew mainView={props.mainView} view={view} onBack={changeView} userData={props.userData} tabSelected={selectedRow}  className={"gocenter nbx_squre txtcloud btn_full"}  onSucess={getTab} title={ tab.nazwisko + " " + tab.imie } ></AlertsNew>       
            </div>
                
                {table}        
            </div>


        </div>

    )

}

export default Alerts;